import { createActionTypes } from '@lifeomic/phc-web-toolkit/dist/redux/util/createActionTypes';

export default createActionTypes(['APP_ERRORS_REGISTER_ERROR']);
